import { useState } from "react";
import Button from "../../../../components/form/button";
import DataLabel from "../../../../components/ui/DataLabel";
import ImagePreviewer from "../../../../components/ui/image-previewer";
import { useSingleBusinessVerification } from "../../../../composables/business-merchant/verification/useSingleBusinessVerification";
import { strReplace } from "../../../../lib/helper-support";
import { useApi } from "../../../../providers/ApiProvider";
import DefaultModal from "../../../../components/modal/default-modal";
import FlagReasonModal from "./flag-reason-modal";

const CompanyInformationVerification = ({ open, code, onClose, verified }: { open: boolean, code: string, onClose?: () => void, verified: boolean }) => {
    const [openImage, setOpenImage] = useState(false);
    const { data } = useSingleBusinessVerification({
        type: 'company_information',
        enabled: open && !!code,
        code,
    });

    const api = useApi();

    const [openFlag, setOpenFlag] = useState(false);

    const approval = async (flagReason?: string) => {
        const status = flagReason ? 'rejected' : 'approved';
        const res = await api.POST({
            endpoint: `business-merchant/${code}/documentation/approval`,
            payload: {
                type: 'company_information',
                status,
                flagged_reason: flagReason,
            },
            refreshKeys: [
                ['business-merchant', 'documentation', code],
            ],
        });

        if (!res) return;
        setOpenFlag(false);
        onClose && onClose();
    }

    return (
        <>
            <FlagReasonModal
                open={openFlag}
                onClose={() => setOpenFlag(false)}
                submitReason={approval}
                submitting={api.postLoading}
            />

            <div className="space-y-4 grid">
                <DataLabel label="Type of Business" value={<span className="capitalize">{strReplace(data?.type_of_business || '-', '_', ' ')}</span>} />
                <DataLabel label="Government Registration Number" value={data?.rc_number || '-'} />
                <DataLabel label="Nature of Business" value={data?.nature_of_business || '-'} />
                <DataLabel label="Description of Business Activity" value={data?.description_of_business_activity || '-'} />
                <DataLabel label="Business Email" value={data?.business_email || '-'} />
                <DataLabel label="Business Phone" value={data?.business_phone_number} />
                <DataLabel label="Website" value={data?.business_website || '-'} />
                <DataLabel label="Address" value={data?.business_address || '-'} />
                <div>
                    <div>
                        <Button onClick={() => setOpenImage(true)} design="primary-outline" text="View Proof of Address" />
                        <ImagePreviewer open={openImage} onClose={() => setOpenImage(false)} image={data?.proof_of_address?.url} />
                    </div>
                </div>
                {!verified && (
                    <div className="flex gap-4 flex-wrap">
                        <DefaultModal
                            onConfirmationAction={() => approval()}
                            modalButtonTriggerText={<Button text="Approve" />}
                            description="Are you sure you want to approve the supplied information?"
                        />
                        <Button onClick={() => setOpenFlag(true)} text="Flag an issue" design="primary-danger-outline" />
                    </div>
                )}
            </div>
        </>
    )
}

export default CompanyInformationVerification